import { useTranslation } from 'hooks/api/useTranslation';
import { FC } from 'react';
import Button from 'shared/ui/button/button';
import { Modal } from 'shared/ui/modal/modal';
import { ModalActions } from 'shared/ui/modal/modal-actions/modal-actions';
import cls from './remove-website-modal.module.scss';

interface RemoveWebsiteModalProps {
  isOpen: boolean;
  domain: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const RemoveWebsiteModal: FC<RemoveWebsiteModalProps> = ({
  isOpen,
  domain,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Modal width={450} isOpen={isOpen} onClose={onClose} className={cls.modal}>
      <h3>{t('removeWebsiteHeading')}</h3>
      <p>{t('removeWebsiteDescription', '_global', '', { domain })}</p>
      <ModalActions>
        <Button theme='text' tone='default' onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button theme='filled' tone='default' onClick={onConfirm}>
          {t('removeFromXoviAi')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
